/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type MyGooseGameDashboardCatchUpQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type MyGooseGameDashboardCatchUpQuery = {
  myGooseGameDashboardCatchUp: Pick<
    Types.GooseGameDashboardCatchUp,
    "totalPointsEarned" | "hasUpdates"
  > & {
    progress: Array<
      Pick<
        Types.GooseGameQuestCatchUpItem,
        "completionCount" | "completionLimit" | "pointsEarned" | "occurredAt"
      > & {
        quest: Pick<
          Types.GooseGameQuest,
          | "id"
          | "title"
          | "type"
          | "points_rewarded"
          | "completion_limit"
          | "question_string"
          | "description"
          | "quest_event_activity_category"
        >;
      }
    >;
    completions: Array<
      Pick<
        Types.GooseGameQuestCatchUpItem,
        "completionCount" | "completionLimit" | "pointsEarned" | "occurredAt"
      > & {
        quest: Pick<
          Types.GooseGameQuest,
          | "id"
          | "title"
          | "type"
          | "points_rewarded"
          | "completion_limit"
          | "question_string"
          | "description"
          | "quest_event_activity_category"
        >;
      }
    >;
  };
};

export const MyGooseGameDashboardCatchUpDocument = gql`
  query MyGooseGameDashboardCatchUp {
    myGooseGameDashboardCatchUp {
      totalPointsEarned
      hasUpdates
      progress {
        completionCount
        completionLimit
        pointsEarned
        occurredAt
        quest {
          id
          title
          type
          points_rewarded
          completion_limit
          question_string
          description
          quest_event_activity_category
        }
      }
      completions {
        completionCount
        completionLimit
        pointsEarned
        occurredAt
        quest {
          id
          title
          type
          points_rewarded
          completion_limit
          question_string
          description
          quest_event_activity_category
        }
      }
    }
  }
`;

/**
 * __useMyGooseGameDashboardCatchUpQuery__
 *
 * To run a query within a React component, call `useMyGooseGameDashboardCatchUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGooseGameDashboardCatchUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGooseGameDashboardCatchUpQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGooseGameDashboardCatchUpQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MyGooseGameDashboardCatchUpQuery,
    MyGooseGameDashboardCatchUpQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    MyGooseGameDashboardCatchUpQuery,
    MyGooseGameDashboardCatchUpQueryVariables
  >(MyGooseGameDashboardCatchUpDocument, baseOptions);
}
export function useMyGooseGameDashboardCatchUpLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MyGooseGameDashboardCatchUpQuery,
    MyGooseGameDashboardCatchUpQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    MyGooseGameDashboardCatchUpQuery,
    MyGooseGameDashboardCatchUpQueryVariables
  >(MyGooseGameDashboardCatchUpDocument, baseOptions);
}
export type MyGooseGameDashboardCatchUpQueryHookResult = ReturnType<
  typeof useMyGooseGameDashboardCatchUpQuery
>;
export type MyGooseGameDashboardCatchUpLazyQueryHookResult = ReturnType<
  typeof useMyGooseGameDashboardCatchUpLazyQuery
>;
export type MyGooseGameDashboardCatchUpQueryResult =
  ApolloReactCommon.QueryResult<
    MyGooseGameDashboardCatchUpQuery,
    MyGooseGameDashboardCatchUpQueryVariables
  >;
